import React from 'react';
import logoClair from './assets/aya-logo.png';
import logoSombre from './assets/aya-logo-dark.png';

/**
 * Logo AYA adapté au thème : la version « or & argent » sur fond sombre, la
 * version classique sur fond clair. Le choix se fait en CSS (attribut
 * data-theme sur <html>), ce qui suit instantanément la bascule de thème et
 * force la version claire à l'impression.
 */
function AyaLogo({ className = '', alt = 'AYA Gold & Silver' }) {
  return (
    <>
      <img src={logoClair} className={`${className} logo-clair`} alt={alt} />
      <img src={logoSombre} className={`${className} logo-sombre`} alt="" aria-hidden="true" />
    </>
  );
}

export default AyaLogo;
